var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { createElement as _createElement } from "react";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { useEffect, useMemo, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose, } from "@fortawesome/pro-solid-svg-icons";
import Autocomplete from "@mui/joy/Autocomplete";
import Input from "@mui/joy/Input";
import { useGetModuleListQuery } from "@/store/api";
import { Option, Select } from "@mui/joy";
/** <b>Composant d'affichage en mode édition d'un champ de type parent</b>*/
export default function RelateFieldEdit(_a) {
    var fieldName = _a.fieldName, record = _a.record, onUpdate = _a.onUpdate, fieldMetadata = _a.fieldMetadata, isOnStudio = _a.isOnStudio;
    var t = useTranslation(["common"]).t;
    var idFieldName = fieldMetadata.id_name;
    var defaultValue = useMemo(function () {
        if (!record) {
            return;
        }
        return record[idFieldName] || "";
    }, [idFieldName, record]);
    var parent_type = fieldMetadata.type_name;
    var defaultValueParent = record[parent_type];
    var _b = useState(defaultValue), value = _b[0], setValue = _b[1];
    useEffect(function () {
        setValue(defaultValue);
    }, [defaultValue]);
    //GET all the module
    var moduleList = useGetModuleListQuery({
        table: record[parent_type],
        params: {},
    }).data;
    var options = useMemo(function () {
        var optionsObejct = (moduleList === null || moduleList === void 0 ? void 0 : moduleList.data.records) || [];
        var values = [];
        optionsObejct.forEach(function (element) {
            values.push({ id: element.id, name: element.name });
        });
        return values;
    }, [moduleList]);
    var _c = useState(options), optionList = _c[0], setOptionList = _c[1];
    useEffect(function () {
        setOptionList(options);
    }, [options]);
    var optionsParent = useMemo(function () {
        var optionsObejct = t("app_lists")[fieldMetadata.options] || {};
        var values = [];
        for (var p in optionsObejct) {
            values.push({ value: p, label: optionsObejct[p] });
        }
        return values;
    }, [fieldMetadata.options, t]);
    var clearItem = function () {
        setSelectedOption(null);
        record["parent_id"] = "";
        onUpdate && onUpdate(record);
    };
    var handleOnChange = function (event, value) {
        if (value) {
            setSelectedOption(value);
            record[idFieldName] = value.id;
            onUpdate && onUpdate(record);
        }
        else {
            clearItem();
        }
    };
    var isOptionEqualToValue = function (option, value) {
        return option.id === value.id;
    };
    var moduleRecord = (moduleList === null || moduleList === void 0 ? void 0 : moduleList.data.records) || [];
    var recordNameById = moduleRecord.find(function (item) { return item.id === record[idFieldName]; }) || "";
    var _d = useState(recordNameById), selectedOption = _d[0], setSelectedOption = _d[1];
    useEffect(function () {
        setSelectedOption(recordNameById);
    }, [recordNameById, options]);
    useEffect(function () {
        setValue(defaultValueParent || "");
    }, [defaultValueParent]);
    return (_jsx("span", __assign({ className: "flex items-center cursor-pointer space-x-2" }, { children: isOnStudio ? (_jsx(Input, { type: "text", className: "w-full" })) : (_jsxs(_Fragment, { children: [_jsx(Select, __assign({ className: "w-full h-8 rounded-md border border-[--color-gray-300] p-1 justify-center shadow cursor-pointer", value: defaultValueParent, onChange: function (event, value) {
                        setValue(value || "");
                        setSelectedOption(null);
                        if (onUpdate) {
                            record[parent_type] = value;
                            onUpdate(record);
                        }
                    } }, { children: optionsParent &&
                        optionsParent.map(function (option, index) { return (_jsx(Option, __assign({ value: option.value }, { children: option.label }), option.value)); }) })), _jsx(Autocomplete, { onChange: handleOnChange, value: selectedOption, defaultValue: selectedOption, placeholder: "Search ...", options: optionList, getOptionLabel: function (option) { return option.name || ""; }, sx: { width: "100%" }, disableClearable: false, loadingText: "loading ...", isOptionEqualToValue: isOptionEqualToValue, renderOption: function (props, option, _a) {
                        var selected = _a.selected;
                        var _b = props, ownerState = _b.ownerState, other = __rest(_b, ["ownerState"]);
                        return (_createElement("li", __assign({}, other, { key: option.id, className: "py-1.5 px-2 ".concat(selected ? "bg-blue-100" : "bg-transparent", " hover:bg-gray-50 cursor-pointer") }), (option === null || option === void 0 ? void 0 : option.name) || ""));
                    } }), _jsx("button", __assign({ className: "button secondary", onClick: clearItem }, { children: _jsx(FontAwesomeIcon, { icon: faClose }) }))] })) })));
}
